module.exports={author:"Jose Hernandez Diaz",date:"08/14/2019",publishDate:"08/14/2019",highlighted:!1,tags:"",title:"The Dahlias in Autumn"};